import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import Content from "./Content/container";

import "./style.less";

export type MapProps = RootContainerProps & {
  error: string | null;
  isEmpty: boolean;
};
export interface ActionProps {}
export type CartComponentProps = ActionProps & MapProps;

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Container className="wsc_content_cart" {...getContainerProps(props)}>
      {props.isEmpty ? i18n.infoCartEmpty : <Content {...getRootContainerProps(props)} />}
      {props.error && <div className="error_box">{props.error}</div>}
    </Container>
  );
};
